import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import Utils from "../../../../../utils/Utils";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import {withTranslation} from "react-i18next";
import Input from "../../../../../components/textbox/Input";


class AltreInformazioni extends Component {

    state = {
        altreInformazioni: {
            storiaRecentePartnerSessuali: {
                storiaRecente: 0,
            },
            contattoMammiferiCompagnia: {
                contatto: 0,
                tipoContatto: ""
            },
            statoGravidanza:{
                gravidanza: 0,
                settimanaGestazione: ""
            },
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.altreInformazioni) {
            let altreInformazioni = this.state.altreInformazioni;
            let altreInformazioniCopia = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici))
            altreInformazioni.storiaRecentePartnerSessuali.storiaRecente = altreInformazioniCopia.altreInformazioni.storiaRecentePartnerSessuali && altreInformazioniCopia.altreInformazioni.storiaRecentePartnerSessuali.storiaRecente ? altreInformazioniCopia.altreInformazioni.storiaRecentePartnerSessuali.storiaRecente: 0
            altreInformazioni.contattoMammiferiCompagnia.contatto = altreInformazioniCopia.altreInformazioni.contattoMammiferiCompagnia && altreInformazioniCopia.altreInformazioni.contattoMammiferiCompagnia.contatto ? altreInformazioniCopia.altreInformazioni.contattoMammiferiCompagnia.contatto: 0
            altreInformazioni.contattoMammiferiCompagnia.tipoContatto = altreInformazioniCopia.altreInformazioni.contattoMammiferiCompagnia && altreInformazioniCopia.altreInformazioni.contattoMammiferiCompagnia.tipoContatto ? altreInformazioniCopia.altreInformazioni.contattoMammiferiCompagnia.tipoContatto: ""
            altreInformazioni.statoGravidanza.gravidanza = altreInformazioniCopia.altreInformazioni.statoGravidanza && altreInformazioniCopia.altreInformazioni.statoGravidanza.gravidanza ? altreInformazioniCopia.altreInformazioni.statoGravidanza.gravidanza: 0
            altreInformazioni.statoGravidanza.settimanaGestazione = altreInformazioniCopia.altreInformazioni.statoGravidanza && altreInformazioniCopia.altreInformazioni.statoGravidanza.settimanaGestazione ? altreInformazioniCopia.altreInformazioni.statoGravidanza.settimanaGestazione: ""
            this.setState({altreInformazioni: altreInformazioni})
        }
        this.props.setAltreInformazioni(this.state.altreInformazioni, this, undefined)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let objBackend = this.createJsonForBackend();
            this.props.setAltreInformazioni(this.state.altreInformazioni, this, objBackend)
        }

    }

    createJsonForBackend() {
        let altreInformazioni = Object.assign({}, this.state.altreInformazioni)
        return Utils.removeFieldFromObject(altreInformazioni, "corretto");
    }

    validate() {
        let objFinal = this.createJsonForBackend()
        this.props.setAltreInformazioni(this.state.altreInformazioni, this, objFinal);

    }

    riceviValore(field, event) {
        let altreInformazioni = this.state.altreInformazioni
        if (field.includes("storiaRecente")) {
            altreInformazioni.storiaRecentePartnerSessuali.storiaRecente = event.target.value
        } else if (field.includes("contatto")) {
            altreInformazioni.contattoMammiferiCompagnia.contatto = event.target.value
            if (event.target.value === "02") {
                altreInformazioni.contattoMammiferiCompagnia.tipoContatto = ""
            }
        } else if (field.includes("tipoContatto")) {
            altreInformazioni.contattoMammiferiCompagnia.tipoContatto = event.target.value
        } else if (field.includes("gravidanza")) {
            altreInformazioni.statoGravidanza.gravidanza = event.target.value
            if (event.target.value === "02") {
                altreInformazioni.statoGravidanza.settimanaGestazione = ""
            }
        } else if (field.includes("settimanaGestazione")) {
            altreInformazioni.statoGravidanza.settimanaGestazione = event.target.value
        }
        this.setState({altreInformazioni: altreInformazioni})
    }


    render() {

        const {t} = this.props
        return (


            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>{t("DatiSpecifici.AltreInformazioni.titolo")}</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("DatiSpecifici.AltreInformazioni.StoriaRecentePartnerSessuali.domanda")}</b>
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"partnerPreSi"}
                                             name={"storiaRecente"}
                                             label={t("DatiSpecifici.AltreInformazioni.StoriaRecentePartnerSessuali.risposte.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             checked={this.state.altreInformazioni.storiaRecentePartnerSessuali.storiaRecente === "01"}>
                                </RadioButton>
                                <RadioButton id={"partnerPreNo"}
                                             name={"storiaRecente"}
                                             label={t("DatiSpecifici.AltreInformazioni.StoriaRecentePartnerSessuali.risposte.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             checked={this.state.altreInformazioni.storiaRecentePartnerSessuali.storiaRecente === "02"}
                                />
                                <RadioButton id={"partnerPreNonSo"}
                                             name={"storiaRecente"}
                                             label={t("DatiSpecifici.AltreInformazioni.StoriaRecentePartnerSessuali.risposte.preferiscoNonRispondere")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             checked={this.state.altreInformazioni.storiaRecentePartnerSessuali.storiaRecente === "03"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px", alignItems: "center", display: "flex"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("DatiSpecifici.AltreInformazioni.ContattoMammiferiCompagnia.domanda")}</b>
                            </p>
                        </div>
                        <div className="col-lg-2">
                            <div className="row">
                                <RadioButton id={"contattoMammSi"}
                                             name={"contatto"}
                                             label={t("DatiSpecifici.AltreInformazioni.ContattoMammiferiCompagnia.risposte.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             checked={this.state.altreInformazioni?.contattoMammiferiCompagnia?.contatto === "01"}>
                                </RadioButton>
                                <RadioButton id={"contattoMammNo"}
                                             name={"contatto"}
                                             label={t("DatiSpecifici.AltreInformazioni.ContattoMammiferiCompagnia.risposte.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             checked={this.state.altreInformazioni?.contattoMammiferiCompagnia?.contatto === "02"}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <p className={styles.testo}>
                                {t("DatiSpecifici.AltreInformazioni.ContattoMammiferiCompagnia.infoAggiuntiveMammiferoCompagnia")}
                            </p>
                            <Input
                                type={"textarea"}
                                id={"tipoContattoMammiferiCompagnia"}
                                field={"tipoContatto"}
                                onChange={this.riceviValore}
                                value={this.state.altreInformazioni.contattoMammiferiCompagnia.tipoContatto}
                                placeholder={"Informazioni aggiuntive mammiferi da compagnia"}
                                disabled={this.state.altreInformazioni.contattoMammiferiCompagnia.contatto === "02" || !this.state.altreInformazioni.contattoMammiferiCompagnia.contatto}
                            />
                        </div>
                    </div>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px", alignItems: "center", display: "flex"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("DatiSpecifici.AltreInformazioni.StatoGravidanza.domanda")}</b>
                            </p>
                        </div>
                        <div className="col-lg-2">
                            <div className="row">
                                <RadioButton id={"gravidanzaSi"}
                                             name={"gravidanza"}
                                             label={t("DatiSpecifici.AltreInformazioni.StatoGravidanza.risposte.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             checked={this.state.altreInformazioni?.statoGravidanza?.gravidanza === "01"}>
                                </RadioButton>
                                <RadioButton id={"gravidanzaNo"}
                                             name={"gravidanza"}
                                             label={t("DatiSpecifici.AltreInformazioni.StatoGravidanza.risposte.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             checked={this.state.altreInformazioni?.statoGravidanza?.gravidanza === "02"}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <p className={styles.testo}>
                                {t("DatiSpecifici.AltreInformazioni.StatoGravidanza.settimanaGestazione")}
                            </p>
                            <Input
                                type={"textarea"}
                                id={"settimanaGestazione"}
                                field={"settimanaGestazione"}
                                onChange={this.riceviValore}
                                value={this.state.altreInformazioni.statoGravidanza.settimanaGestazione}
                                placeholder={"Settimana di gestazione"}
                                disabled={this.state.altreInformazioni.statoGravidanza.gravidanza === "02" || !this.state.altreInformazioni.statoGravidanza.gravidanza}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(AltreInformazioni);
